import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '../button-reusable/button-reusable';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [ButtonComponent],
  template: `
    <div
      class="w-full min-h-[260px]
             rounded-2xl border-2 border-dashed border-slate300
             bg-white flex flex-col items-center justify-center
             gap-4 text-center p-6"
      >
      <h2 class="text-lg font-semibold text-slate800">
        {{ title }}
      </h2>
    
      @if (description) {
        <p class="text-sm text-slate500 max-w-md">
          {{ description }}
        </p>
      }
    
      @if (buttonLabel) {
        <app-button-reusable
          type="button"
          size="md"
          (clicked)="onAction()"
          >
          {{ buttonLabel }}
        </app-button-reusable>
      }
    </div>
    `
})
export class EmptyStateComponent {
  @Input() title: string = 'No Data Found';
  @Input() description?: string;
  @Input() buttonLabel?: string;

  @Output() action = new EventEmitter<void>();

  onAction(): void {
    this.action.emit();
  }
}
